import * as router from "react-router-dom";

// Reexport so it can be stubbed
export const useNavigate = () => router.useNavigate();
export const useParams = () => router.useParams();
